<template>
  <div class="accent">
    <v-container fluid align="center" justify="center" class="py-2">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card elevation="0" class="pg-main-card tw-mt-2 md:tw-mt-4">
            <div class="pg-header">
              <div class="pg-badge">
                <v-icon color="white">mdi-car-cog</v-icon>
              </div>
              <h2 class="pg-title">Parts Management</h2>
            </div>
            <v-divider class="mb-3" />
            <div class="pg-table">
              <parts-management-table></parts-management-table>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  components: {
    partsManagementTable: () =>
      import('@/components/parts-management/PartsManagementTable'),
  },
}
</script>

<style scoped>
/* Soft-edged card design language (matches BidSubmitted / BidDetails) */
.pg-main-card {
  border-radius: 18px;
  border: 1px solid #e8edf5;
  background: #ffffff;
  padding: 18px 20px 20px;
}
.pg-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.pg-badge {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #034ea2 0%, #0a63c4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(3, 78, 162, 0.25);
}
.pg-title {
  font-size: 20px;
  font-weight: 800;
  color: #0f2a55;
  margin: 0;
}
.pg-table {
  border-radius: 12px;
  border: 1px solid #eef2f8;
  overflow: hidden;
}
.pg-table ::v-deep .v-data-table.elevation-1 {
  box-shadow: none !important;
}
</style>
